var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.folders)?_c('FolderList',{attrs:{"items":_vm.filteredFolders},on:{"select":_vm.select}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }